export const capitalize = (str: string): string =>
  str
    ?.split(' ')
    .map((el) => el.charAt(0).toUpperCase() + str.slice(1).toLowerCase())
    .join(' ') ?? '';
